import { Elm } from "./Main.elm";

export function run({ node, baseUrl, sessionToken }) {
  const app = Elm.Main.init({
    node,
    flags: {
      baseUrl,
      sessionToken,
    },
  });

  app.ports.onDragStart.subscribe(function (event) {
    // This is required for Firefox to properly handle drag&drop.
    event.dataTransfer.setData("text", "");
  });

  return {
    persistSessionToken: app.ports.persistSessionTokenCmd,
    requestLogin: app.ports.requestLoginCmd,
    requestLoginCallbackProcessing: app.ports.requestLoginCallbackProcessingCmd,
    requestLogout: app.ports.requestLogoutCmd,
    reportLoginReceived: (id_token) => {
      app.ports.loginReceivedReceiver.send(id_token);
    },
  };
}
